import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { isBrowser } from 'Helpers/Browser';
import { I18n } from 'react-redux-i18n';

import { redirect } from 'Helpers/Uri';
import { getParams } from 'Helpers/Search';
import { getFullSlug } from 'Helpers/Photos';
import { isPhotoInLocalStorageCart } from 'Helpers/Cart';
import { getRouteByName } from 'Helpers/Routes';

import Head from 'Components/helpers/Head';
import GalleryHeader from 'Components/layout/GalleryHeader';
import GalleryNoResult from 'Components/layout/GalleryNoResult';
import Gallery from 'Components/layout/Gallery';
import Pagination from 'Components/layout/Pagination';
import RelatedList from 'Components/public/tags/RelatedList';
import Spinner from 'Components/layout/Spinner';

import { search, updatePhotos } from 'Redux/actions/photos';
import { seo, related } from 'Redux/actions/tags';
import { addItem as cartAddItem } from 'Redux/actions/cart';
import { addItem as lightboxAddItem, removeItem as lightboxRemoveItem } from 'Redux/actions/lightbox';

@connect(
    (state) => ({
        tags: state.tags,
        photos: state.photos,
        user: state.user
    }), { search, updatePhotos, seo, related, cartAddItem, lightboxAddItem, lightboxRemoveItem }
)
export default class Tag extends React.Component {
    static propTypes = {
        search: PropTypes.func.isRequired,
        seo: PropTypes.func.isRequired,
        related: PropTypes.func.isRequired,
        cartAddItem: PropTypes.func.isRequired,
        lightboxAddItem: PropTypes.func.isRequired,
        lightboxRemoveItem: PropTypes.func.isRequired,
        updatePhotos: PropTypes.func.isRequired,
        tags: PropTypes.shape({
            tags: PropTypes.objectOf(
                PropTypes.shape({
                    isPending: PropTypes.bool.isRequired,
                    isLoaded: PropTypes.bool.isRequired,
                    tag: PropTypes.shape({
                        name: PropTypes.string.isRequired,
                        slug: PropTypes.string.isRequired
                    })
                })
            ).isRequired,
            related: PropTypes.objectOf(
                PropTypes.shape({
                    isPending: PropTypes.bool.isRequired,
                    isLoaded: PropTypes.bool.isRequired,
                    tags: PropTypes.arrayOf(PropTypes.shape({
                        name: PropTypes.string.isRequired,
                        slug: PropTypes.string.isRequired
                    })).isRequired
                })
            )
        }).isRequired,
        photos: PropTypes.shape({
            search: PropTypes.shape({
                isPending: PropTypes.bool.isRequired,
                isLoaded: PropTypes.bool.isRequired,
                photos: PropTypes.arrayOf(
                    PropTypes.object
                ).isRequired,
                params: PropTypes.object
            })
        }).isRequired,
        user: PropTypes.shape({
            currentBusinessId: PropTypes.string,
            currentBrandId: PropTypes.string,
            accessToken: PropTypes.string,
            profile: PropTypes.shape({
                admin: PropTypes.bool.isRequired
            })
        }),
        params: PropTypes.shape({
            slug: PropTypes.string,
            page: PropTypes.string
        }).isRequired
    };
    static defaultProps = {
        params: {
            slug: '',
            page: ''
        }
    };

    perPage = 40;

    componentDidMount = () => {
        this.loadContent(this.props);
    }

    componentWillReceiveProps = nextProps => {
        const { query: slug, pageNumber, pageString } = getParams({ query: nextProps.params.slug, page: nextProps.params.page });

        if (!nextProps.tags.tags[slug] || !nextProps.tags.tags[slug].tag) {
            return false;
        }

        if (
            (nextProps.photos.search.params.businessId !== nextProps.user.currentBusinessId) ||
            (nextProps.photos.search.params.brandId !== nextProps.user.currentBrandId)
        ) {
            this.loadPhotos(nextProps.tags.tags[slug].tag.name, pageNumber, nextProps.user.currentBusinessId, nextProps.user.currentBrandId);
        } else {
            this.loadContent(nextProps);
        }
    }

    loadContent = props => {
        const { tags, related } = props.tags;
        const { search } = props.photos;
        const { query: slug, pageNumber, pageString } = getParams({ query: props.params.slug, page: props.params.page });

        if (!tags.hasOwnProperty(slug)) {
            this.loadTag(slug);
        } else if (!tags[slug].isPending && tags[slug].isLoaded) {
            //If tag doesnt exits, redirect to search
            if (!tags[slug].tag || !tags[slug].tag.name) {

                redirect(getRouteByName('search', { query: slug }).path);
            } else {
                const tagName = tags[slug].tag.name;

                //Load photos
                if (
                    !search.isPending && search.isLoaded && search.params.query === tagName && search.params.page === pageNumber &&
                    search.params.businessId === this.props.user.currentBusinessId && search.params.brandId === this.props.user.currentBrandId
                ) {
                    if (pageNumber > search.lastPage) {
                        //If user is above last page, redirect user to last page
                        redirect(getRouteByName('tag', { slug: slug, page: search.lastPage > 1 ? 'page-' + search.lastPage : '' }).path + window.location.search);
                    }
                } else if (!search.isPending) {
                    this.loadPhotos(tagName, pageNumber, this.props.user.currentBusinessId, this.props.user.currentBrandId);
                }

                //Load related tags
                if (!related.hasOwnProperty(slug)) {
                    this.loadRelatedTags(slug, tagName);
                }
            }
        }
    }

    loadPhotos = (query, pageNumber) => {
        this.props.search({
            query: query,
            page: pageNumber,
            perPage: this.perPage,
            businessId: this.props.user.currentBusinessId,
            brandId: this.props.user.currentBrandId
        });
    }
    loadTag = slug => {
        this.props.seo({
            slug: slug
        });
    }
    loadRelatedTags = (slug, name) => {
        this.props.related({
            slug: slug,
            tags: name.split(' ')
        });
    }

    render() {
        const { perPage } = this;
        const { search } = this.props.photos;
        const { tags, related } = this.props.tags;
        const { query: slug, pageNumber, pageString } = getParams({ query: this.props.params.slug, page: this.props.params.page });

        const currentTag = tags.hasOwnProperty(slug) ? tags[slug].tag : null;
        const currentRelatedTags = related.hasOwnProperty(slug) ? related[slug].tags : [];

        if (!currentTag) {
            return (
                <div className="container-tag">
                    <Spinner />
                </div>
            );
        }

        return (
            <div className="container-tag">
                <Head
                    title={`${currentTag.name} images, pictures and stock photos`}
                    description={`${currentTag.name} images and pictures. Over ${search.totalCount} stock photos of ${currentTag.name} from community of Foap’s photographers.`}
                    canonical={getRouteByName('tag', { slug: slug, page: pageNumber && pageNumber > 1 ? pageString : '' }).path}
                    robots={'noindex, nofollow'}
                    relPrev={pageNumber > 1 ? getRouteByName('tag', { slug: slug, page: pageString.replace(pageNumber, (pageNumber - 1)) }).path : null}
                    relNext={pageNumber < search.lastPage ? getRouteByName('tag', { slug: slug, page: pageString.replace(pageNumber, (pageNumber + 1)) }).path : null}
                />
                <div className="container-fluid">
                    <GalleryHeader
                        header={<div><h1>{currentTag.name || currentTag.slug} Photos</h1> <p><strong>{currentTag.name || currentTag.slug}</strong> - {search.totalCount} Stock Photos</p></div>}
                    />
                    <Gallery
                        isLoading={search.isPending || !this.props.tags.tags.hasOwnProperty(slug)}
                        noResultInfo={<GalleryNoResult query={slug ? slug : ''} page={pageNumber} />}
                        overlayType={'default'}
                        photos={search.photos.map(photo => ({
                            ...photo,
                            href: getRouteByName('singlePhoto', { slug: getFullSlug(photo) }).path,
                            controls: {
                                curate: {
                                    visible: this.props.user.profile && this.props.user.profile.admin
                                },
                                addToCart: {
                                    disabled: photo.isInCart || isPhotoInLocalStorageCart(photo),
                                    visible: !photo.downloadUrl && (!this.props.user.accessToken || photo.purchasable),
                                    trigger: photo => this.props.cartAddItem(photo, 'tag')
                                        .then(this.props.updatePhotos([{ id: photo.id, payload: { isInCart: true } }]))
                                },
                                addToLightbox: {
                                    disabled: photo.isInLightbox,
                                    visible: !!this.props.user.accessToken && !photo.isInLightbox,
                                    trigger: photo => this.props.lightboxAddItem(photo, 'tag')
                                        .then(this.props.updatePhotos([{ id: photo.id, payload: { isInLightbox: true } }]))
                                },
                                removeFromLightbox: {
                                    disabled: !photo.isInLightbox,
                                    visible: !!this.props.user.accessToken && photo.isInLightbox,
                                    trigger: photo => this.props.lightboxRemoveItem(photo, 'tag')
                                        .then(this.props.updatePhotos([{ id: photo.id, payload: { isInLightbox: false } }]))
                                },
                                download: {
                                    disabled: false,
                                    visible: photo.downloadUrl
                                }
                            }
                        }))}
                    />
                    <Pagination
                        totalElements={parseInt(search.totalCount)}
                        elementsPerPage={parseInt(perPage)}
                        currentPage={parseInt(pageNumber)}
                        link={getRouteByName('tag', { slug: slug, page: 'page-%pageNumber%' }).path}
                    />
                    <RelatedList
                        title={`${I18n.t('TAGS.relatedList.title')} ${currentTag.name || currentTag.slug}`}
                        tags={currentRelatedTags}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/global/Tag/index.js